/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetRecord = require('../../common/services/GetRecord');
var GetAllRecordLookups = require('../../common/services/GetAllRecordLookups');
var CorpFinInvHistoryEditView = require('../views/CorpFinInvHistoryEditView');
var GetInvestmentHistory = require('../services/GetInvestmentHistory');

module.exports = function(recordId, invHistoryId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetRecord(recordId), GetInvestmentHistory(invHistoryId), GetAllRecordLookups())
    .done(function(record, invHistory, lookups) {
      NavUtils.navigate('corpfin/investment/' + recordId + '/investment-history/' + invHistoryId + '/edit');
      Scaffold.content.show(
        new CorpFinInvHistoryEditView({
          viewMode: 'int',
          model: new Backbone.Model({
            recordId: recordId,
            record: record,
            invHistoryId: invHistoryId,
            invHistory: invHistory,
            investmentHistoryStatuses: lookups.recordStatuses,
            transactionDescriptions: lookups.investmentHistoryTransactions
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
